import { render, staticRenderFns } from "./ProductListPrice.vue?vue&type=template&id=2b4af7b7&scoped=true"
import script from "./ProductListPrice.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductListPrice.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductListPrice.vue?vue&type=style&index=0&id=2b4af7b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4af7b7",
  null
  
)

export default component.exports